
import { HTMLAttributes, ReactNode } from "react";
import { ModalEdit } from "./ModalEdit";

export interface IModalEditProps extends HTMLAttributes<HTMLDivElement> {
	type?: "text" | "textarea" | "number" | "custom";
	initValue?: string;
	hint?: string;
	closeOutside?: boolean;
	onChangeValue?: ( newValue: string ) => void;
	renderInput?: ( props: ModalInputProps ) => ReactNode;
};

export interface ModalInputProps {
    type?: "text" | "textarea" | "number" | "custom";
	initValue?: string;
	hint?: string;
	closeOutside?: boolean;
    onChangeValue?: ( newValue: string ) => void;
    closeModal: () => void;
};

export default ModalEdit;
